import React from 'react';

import Icon, { IconProp } from '~components/icon';

interface ComponentProps {
  colSpan: number;
  message?: string;
  icon?: IconProp;
}

const TableEmpty: React.FC<ComponentProps> = ({ colSpan, message = 'No data', icon }) => {
  return (
    <tr>
      <td colSpan={colSpan} className="p-5 text-center">
        {icon && (
          <div>
            <Icon icon={icon} size="2x" />
          </div>
        )}
        <div className="mt-3">{message}</div>
      </td>
    </tr>
  );
};

export default TableEmpty;
